<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>申请调拨</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="org-tree-layout" name="org_tree">
            <swb-popover-org-tree :showMgmt="true" :bizDepart="true" :showIncludeSubComs="true" :selectComId="selectComId" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :queryKey="queryKey"
                             :queryHandler="queryHandler"></swb-query-sort-area>
        <div name="tab-container">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全部" name="all"></el-tab-pane>
                <el-tab-pane name="applyInitial">
                    <span slot="label">未申请</span>
                </el-tab-pane>
                <el-tab-pane label="已申请" name="applyApplied"></el-tab-pane>
                <el-tab-pane label="审核已通过" name="auditPass"></el-tab-pane>
                <el-tab-pane label="审核未通过" name="auditFail"></el-tab-pane>
                <el-tab-pane label="已作废" name="invalid"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small " v-if="checkActionPerm('create')" @click="createTransVoucher(false)">
                    <span>制作调拨单</span>
                </button>
                <button class="swb-btn swb-btn-small" v-if="!isAuditBpConfAvailable && checkActionPerm('register')" @click="createTransVoucher(true)">
                    <span>登记调拨单</span>
                </button>
                <button class="swb-btn swb-btn-small" v-if="checkActionPerm('offline')" @click="createTransVoucher(false, true)">
                    <span>资产迁移单</span>
                </button>
            </div>
            <div class="right">
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="doExport">导出</a>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
import { $, Utils } from '../../app.base'
import { DomSizeWatcher, MsgBox, Routes, showPageRangeSelDlg, Vue } from '../../app.vues'
import { checkUserActionPerm } from '../index'
import { getDefaultDownloadPageSize, getDefaultPageSizes } from '../../app.conf'
import { showGrpDownloadDlg } from '../ctrl/dialog'
import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
import { openShopDeviceTransVoucherReturnSaveDlg, openTrandVouhcerPdfDlg } from './showDetailDlg'
import { getMerchtAuditBpConfInfo, openAuditTypeDlg, openDingdingAuditViewDlg, openFeiShuAuditViewDlg, openOaAuditBpNodeDlg, openOaAuditRecDlg } from '../oaAudit/selectDlg'
import { getIncludeSubComsByMetaQueryConf } from '../conf/ComnConfStorer'
//
import shopDevcApi from '../../api/shopDevc'
import assetVchrApi from '../../api/assetVchr'
import userApi from '../../api/user'
import oaAuditApi from '../../api/oaAudit'
//
import SwbShopDeviceTransVoucherSaveStockFifo from './ShopDeviceTransVoucherSaveStockFifo'
import SwbViewShopDeviceTransVoucher from './ShopDeviceTransVoucherView'
import SwbApplyDesc from '../bizUnion/ApplyDesc';
import SwbShopDeviceTransVoucherAudit from './ShopDeviceTransVoucherAudit'
import SwbShopDeviceTransAuditResList from './ShopDeviceTransAuditResList'
import SwbShopDeviceTransVoucherAuditList from './ShopDeviceTransVoucherAuditList'
import SwbShopDeviceRecList from '../retailer/ShopDeviceRecList'
import SwbResultColConf from '../query/ResultColConf.vue';
import SwbResultTable from '../query/ResultTable.vue';
import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
//
Routes.add(SwbShopDeviceTransVoucherSaveStockFifo);
Routes.add(SwbShopDeviceTransVoucherAuditList);
Vue.regist(SwbViewShopDeviceTransVoucher);
Vue.regist(SwbApplyDesc);
Vue.regist(SwbShopDeviceTransVoucherAudit);
Vue.regist(SwbShopDeviceTransAuditResList);
Vue.regist(SwbShopDeviceRecList);
Vue.regist(SwbResultColConf);
Vue.regist(SwbResultTable);
Vue.regist(SwbPopoverOrgTree);

export default {
    name: 'swb-shop-device-trans-voucher-apply-list',
    path: '/shop/device/trans/voucher/apply/list',
    avlActions: 'view_detail|modify|apply|delete|view_audit_rec|create',
    avlScopes: 'retailer',
    desc: '资产调拨列表',
    data: function () {
        return {
            confKey: 'swb-shop-device-trans-voucher-apply-list',
            tableHeight: 300,
            queryOnLoad: true,
            //
            needPager: true, //是否需要分页（默认：true）
            multiSelect: false, //是否多选（默认：false）
            multiPageSelect: false, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: false, //是否显示行号（默认：true）
            rowNoFixed: false, //行号列是否固定（默认：false）

            btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
            //
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 220,//操作列宽度（默认：100）
            //
            btnColFixed: true, //操作列是否固定
            resultColConf: {},
            //
            lastPageNumber: null,
            pageSize: getDefaultPageSizes().first(),
            pageNumber: 1,
            totalCount: 0,
            //
            activeName: 'all',
            //排序、搜索
            queryKey: null,
            comId: null,
            bizUnitId: null,
            bizUnitName: null,
            selectComId: null,
            includeSubComs: false,
            initIncludeSubComs: false,
            exportFilter: {},
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {},
            },
            voucherTypeMap: [],
            no: null,
            innerNo: null,
            initialCount: 0,
            appliedCount: 0,
            auditPassCount: 0,
            isAuditBpConfAvailable: false,
            needAssignAuditors: false,
            dingDingAuditFlag: false,
            feiShuAuditFlag: false,
            scopeEntity: null,
            devcVoucherTypeMap: getEnumMap('devcVoucherType', 'value2text'),
        }
    },
    created: function () {
        let self = this;
        getIncludeSubComsByMetaQueryConf(this.confKey, function (includeSubComs) {
            self.includeSubComs = includeSubComs;
            self.initIncludeSubComs = includeSubComs;
        });
        // 1、检查当前商户是否开启外部审批：获取已就绪的业务审批流、优先级为 seqNo。
        getMerchtAuditBpConfInfo('retailer.assets.allot', false, function (auditBpConfInfo) {
            if(!Utils.isNoB(auditBpConfInfo)) {
                self.needAssignAuditors = Utils.isTrue(auditBpConfInfo.needAssignAuditors);
                self.dingDingAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 2); // 钉钉
                self.feiShuAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 3); // 飞书
                if(!self.dingDingAuditFlag && !self.feiShuAuditFlag) {
                    // 2、如果自建的业务审批流程、检查看商户OA对接点是否就绪
                    self.isMerchtAuditBpConfAvailable();
                }
            } else {
                // 走系统内部审批
            }
        });
        //
        this.voucherTypeMap = getEnumMap('devcVoucherType', 'value2text');
        this.ledgerStateMap = getEnumMap('ledgerState', 'value2text');
        //
        let no = this.$route.query.no || null;
        if(!Utils.isNoB(no)) {
            this.no = no;
            this.queryModel.filterItems.no = no;
        }
        let innerNo = this.$route.query.innerNo || null;
        if(!Utils.isNoB(innerNo)) {
            this.innerNo = innerNo;
            this.queryModel.filterItems.innerNo = innerNo;
        }
        //
        this.getCurrentUserInfo();
    },
    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //根据新主元素的内容大小，调整表格高度
            self.tableHeight = height;
        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout,[name="org_tree"],[name="query-sort-area"],.simple-row,[name="tab-container"]'));
        domSizeWatcher.start(500);
        //
        this.initResultTable();
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if(domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        checkComCatChange: function (eventData) {
            if(Utils.isTrue(eventData.mgmtFlag)) {
                let scopeEntity = this.scopeEntity;
                this.selectComId = scopeEntity.comId;
                this.bizUnitId = scopeEntity.bizUnitId;
                this.bizUnitName = scopeEntity.bizUnitName;
            } else {
                this.selectComId = eventData.id;
                this.bizUnitId = eventData.bizUnitId;
                this.bizUnitName = eventData.bizUnitName;
                this.includeSubComs = eventData.includeSubComs;
            }
            this.getShopDeviceTransVoucherList();
        },
        isMerchtAuditBpConfAvailable: function () {
            let self = this;
            oaAuditApi.isMerchtAuditBpConfAvailable({bizTypeCode: 'retailer.assets.allot'}, function (result) {
                if(result.type == 'info') {
                    self.isAuditBpConfAvailable = Utils.isTrue(result.data);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        onConfigReady: function () {
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            // 生凭状态
            let dataList = [{'value': null, 'label': '- 全部 -'}];
            let ledgerStateList = getEnumList('ledgerState');
            ledgerStateList.forEach(function (item) {
                let ledgerState = {};
                ledgerState.value = item.value;
                ledgerState.label = item.text;
                dataList.push(ledgerState);
            });
            this.updateQueryModelField('ledgerState', dataList);
            //
            if(!Utils.isNoB(this.innerNo)) {
                let data = {value: this.innerNo};
                let fieldInfo = {};
                fieldInfo['innerNo'] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        updateQueryModelField: function (itemCode, dataList = []) {
            if(itemCode != null) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {dataList: dataList};
                let fieldInfo = {};
                fieldInfo[itemCode] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            //
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                'no': function (row, colName, colValue, rowIndex, colConf) {
                    let domHtml = '<span>' + row.no + '</span>';
                    if(row.srcVoucherType != null) {
                        domHtml = domHtml + '<span class="swb-tags swb-tags-danger">' + self.voucherTypeMap[row.srcVoucherType] + '</span>';
                    }
                    return domHtml;
                },
                'suitFlag': function (row, colName, colValue, rowIndex, colConf) {
                    if(colValue) {
                        return '<span >是</span>';
                    } else {
                        return '<span>否</span>';
                    }
                },
                'ledgerStateX': function (row, colName, colValue, rowIndex, colConf) {
                    return '<span>' + self.ledgerStateMap[row.ledgerState] + '</span>';
                },
                'auditStateX': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.invalid) {
                        return '<span class="font-red">已作废</span>';
                    } else if(row.applyState == 0 && row.auditState == 0) {
                        return '<span class="font-gray1">未申请</span>';
                    } else if(row.applyState == 1 && row.auditState === 0) {
                        return '<span class="font-gold">已申请</span>';
                    } else if(row.auditState === 1) {
                        return '<span class="font-green">审核已通过</span>';
                    } else if(row.auditState === -1) {
                        return '<span class="font-red">审核未通过</span>';
                    }
                },
                'receiptStateX': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.receiptState == 0 || row.receiptState == -1) {
                        return '<span class="font-gray1">未验收</span>';
                    } else if(row.receiptState == 1) {
                        return '<span class="font-gold">部分验收</span>';
                    } else if(row.receiptState == 2) {
                        return '<span class="font-green">全部验收</span>';
                    }
                },
                'returnStateX': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.returnState == 0 || row.returnState == -1) {
                        return '<span class="font-gray1">未退还</span>';
                    } else if(row.returnState == 1) {
                        return '<span class="font-gold">部分退还</span>';
                    } else if(row.returnState == 2) {
                        return '<span class="font-green">全部退还</span>';
                    }
                },
                'confirmStateX': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.confirmState == 0) {
                        return '<span class="font-gray1">未完成</span>';
                    } else {
                        return '<span class="font-green">已完成</span>';
                    }
                },
                'srcVoucherTypeX': function (row, colName, colValue, rowIndex) {
                    if(row.srcVoucherType != null) {
                        return '<span>' + self.devcVoucherTypeMap[row.srcVoucherType] + '</span>';
                    } else {
                        return '';
                    }
                },
                'actions': function (row, colName, colValue, rowIndex) {
                    let btnList = [];
                    if(self.checkActionPerm('apply', null, row.srcComId) && row.applyState != 1 && !row.invalid && row.auditState != 1 && (self.bizUnitId == row.creatorBizUnitId || self.bizUnitId == row.srcBizUnitId)) {
                        btnList.push({
                            name: 'apply',
                            text: '申请'
                        })
                    }
//                        if(self.checkActionPerm('apply') && self.isAuditBpConfAvailable && row.applyState == 1 && !row.invalid && row.outerAuditFlag && !row.bpInstStarted && row.auditState != 1 && (self.bizUnitId == row.creatorBizUnitId || self.bizUnitId == row.srcBizUnitId)) {
//                            btnList.push({
//                                name: 'openOuterBpStartWin',
//                                text: '申请'
//                            })
//                        }
                    if(self.checkActionPerm('modify', null, row.srcComId) && !row.invalid && row.applyState != 1 && row.auditState != 1 && (self.bizUnitId == row.creatorBizUnitId || self.bizUnitId == row.srcBizUnitId)) {
                        btnList.push({
                            name: 'modify',
                            text: '修改'
                        })
                    }
                    if(self.checkActionPerm('invalid', null, row.srcComId) && (row.applyState == 0 || row.applyState == 2) && row.auditState <= 0 && !row.invalid && (self.bizUnitId == row.creatorBizUnitId || self.bizUnitId == row.srcBizUnitId)) {
                        btnList.push({
                            name: 'invalid',
                            text: '作废'
                        })
                    }
                    if(self.checkActionPerm('view_detail', null, row.srcComId)) {
                        btnList.push({
                            name: 'view_detail',
                            text: '查看详情'
                        })
                    }
                    if(self.checkActionPerm('pdfExport', null, row.srcComId)) {
                        btnList.push({
                            name: 'pdfExport',
                            text: '业务单据'
                        })
                    }
                    if(self.checkActionPerm('taxRateChange', null, row.srcComId) && !row.invalid && row.auditState != 1 && row.applyState != 1) {
                        btnList.push({
                            name: 'taxRateChange',
                            text: '调整税率'
                        })
                    }
                    if(self.checkActionPerm('view_rec', null, row.srcComId)) {
                        btnList.push({
                            name: 'view_rec',
                            text: '操作记录'
                        })
                    }
                    if(row.outerAuditFlag && row.applyState != 0 && self.checkActionPerm('audit_rec', null, row.srcComId)) {
                        btnList.push({
                            name: 'audit_rec',
                            text: '单据审批记录'
                        })
                    }
                    if(self.checkActionPerm('delete', null, row.srcComId) && row.invalid && (self.bizUnitId == row.creatorBizUnitId || self.bizUnitId == row.srcBizUnitId)) {
                        btnList.push({
                            name: 'delete',
                            text: '删除'
                        })
                    }
                    if(self.checkActionPerm('return', null, row.srcComId) && self.checkActionPerm('return', null, row.dstComId) && row.confirmState == 0 && row.auditState == 1 && (row.dstBizUnitId == self.bizUnitId || row.srcBizUnitId == self.bizUnitId)) {
                        btnList.push({
                            name: 'return',
                            text: '退还'
                        })
                    }
                    return btnList;
                }
            }, /* 单元格按钮点击处理函数 */{
                //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                'actions': function (row, colName, colValue, rowIndex, btnName) {
                    if(!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                        return;
                    }
                    if(btnName == 'modify') {
                        self.editorTransVoucher(row)
                    } else if(btnName == 'apply') {
                        self.applyTransVoucher(row);
                    } else if(btnName == 'invalid') {
                        self.doInvalidTransVoucher(row.id);
                    } else if(btnName == 'delete') {
                        self.doDeleteTransVoucher(row.id);
                    } else if(btnName == 'view_detail') {
                        self.viewTransVoucher(row);
                    } else if(btnName == 'view_rec') {
                        self.showActRec(row.no);
                    } else if(btnName == 'pdfExport') {
                        self.pdfExport(row.id);
                    } else if(btnName == 'openOuterBpStartWin') {
                        self.openOuterBpStartWin(row);
                    } else if(btnName == 'audit_rec') {
                        self.auditRscDlg(row.no, row.innerNo, row.auditSeqNo);
                    } else if(btnName == 'return') {
                        self.returnTransVoucher(row.id);
                    } else if(btnName == 'taxRateChange') {
                        self.taxRateChange(row);
                    }
                }
            });
        },
        taxRateChange: function (row) {
            let self = this;
            let path = SwbShopDeviceTransVoucherSaveStockFifo.path;
            this.$router.push({
                path: path,
                query: {
                    id: row.id,
                    taxRateChange: true,
                    isAuditBpConfAvailable: self.isAuditBpConfAvailable,
                    parentPath: '/shop/device/trans/voucher/apply/list'
                }
            });
        },
        auditRscDlg: function (no, innerNo, auditSeqNo) {
            let bizVoucherNo = no;
            if(!Utils.isNoB(innerNo)) {
                bizVoucherNo = innerNo;
            }
            openOaAuditRecDlg('retailer.assets.allot', auditSeqNo, bizVoucherNo);
        },
        renderTable(rows, pagination) {
            //
            let resultTable = this.$refs.result_table;
            //清除数据（如果已经渲染的数据与新的列不是一回事儿）
            //resultTable.clear();
            //同步使用新的自定义列信息
            //resultTable.initMeta(confColList);
            //设置新数据
            let tableData = {
                rows: rows,
                pagination: pagination
            };

            resultTable.render(tableData);
        },
        // 单元格点击事件
        rowDblClickHandler: function (row) {
            if(!this.multiSelect) {
                console.log('----- 双击数据行 ----');
                console.log(row);
            }
        },
        pageNoChangeHandler: function (pageNumber, pageSize) {
            console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
            //
            this.pageSize = pageSize;
            this.pageNumber = pageNumber;
            this.lastPageNumber = null;
            //
            this.getShopDeviceTransVoucherList();
        },
        // 操作权限控制
        checkActionPerm: function (action, targetPostId, dataOwnerComId) {
            return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId, dataOwnerComId);
        },
        getCurrentUserInfo: function () {
            let self = this;
            userApi.getUserInfoByContext({}, function (result, jqXhr) {
                if(result.type == 'info') {
                    let data = result.data;
                    self.scopeEntity = data.scopeEntity;
                    self.comId = data.scopeEntity.comId;
                    self.selectComId = data.scopeEntity.bizUnitId;
                    self.bizUnitId = data.scopeEntity.bizUnitId;
                    self.bizUnitName = data.scopeEntity.bizUnitName;
                    if(self.includeSubComs) {
                        self.selectComId = data.scopeEntity.bizUnitId;
                        self.selectComName = data.scopeEntity.comName;
                        self.bizUnitId = data.scopeEntity.bizUnitId;
                        self.bizUnitName = data.scopeEntity.bizUnitName;
                        self.comLevel = data.scopeEntity.comLevel;
                    }
                } else {
                    self.$message.error(result.message);
                }
            });
        },
        queryHandler(queryModel) {
            //1、接收查询条件
            this.queryModel = queryModel;
            //缓存查询条件
            this.pageNumber = 1;
            this.lastPageNumber = null;
            this.getShopDeviceTransVoucherList(this.checkStateValue);
        },
        // 页签切换
        handleClick: function () {
            //
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let hidden = false;
            if(this.activeName != 'all') {
                hidden = true;
            }
            let data = {hidden: hidden};
            let fieldInfo = {};
            fieldInfo['transFlag'] = data;
            query_model_ctrl.updateFields(fieldInfo);
            //
            this.pageNumber = 1;
            this.getShopDeviceTransVoucherList();
        },
        openOuterBpStartWin: function (row) {
            let bizVoucherNo = row.no;
            if(!Utils.isNoB(row.innerNo)) {
                bizVoucherNo = row.innerNo;
            }
            // let pageUrl = 'https://qa-oa-bpm.wumart.com/portal/r/w?cmd=com.awspaas.user.apps.assets.swb.redirectCmd&dircmd=CLIENT_BPM_FORM_MAIN_PAGE_OPEN&user_id=00000194&processInstId=706a1357-1f27-4692-9d08-0a42c8e94de2&sig=d6dbd24ddff9c6f98516e2992fd5de35';
            let params = {};
            params.bizTypeCode = 'retailer.assets.allot';
            params.bizVoucherNo = bizVoucherNo;
            params.auditSeqNo = row.auditSeqNo;
            oaAuditApi.getBpStartPageUrl(params, function (result) {
                if(result.type === 'info') {
                    let pageUrl = result.data;
                    Utils.openWindow(pageUrl);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getShopDeviceTransVoucherList: function () {
            let self = this;

            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            //
            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            filterItems.ioFlag = self.ioFlag;
            filterItems.tabFlag = 'out';
            filterItems.fiscalAcctFlag = true;  // 资产调拨
            //
            if(!Utils.isNoB(this.no)) {
                filterItems.no = this.no;
            }
            filterItems.tabCheckFlag = self.activeName;
            //
            if(!Utils.isNoB(filterItems.returnState)) {
                filterItems.returnFlag = true;
            }
            if(!Utils.isNoB(filterItems.receiptState)) {
                if(filterItems.receiptState == 3) {
                    // 全部退还验收
                    filterItems.receiptState = null;
                    filterItems.returnFlag = true;
                    filterItems.returnState = 2;
                } else if(filterItems.receiptState == 2 || filterItems.receiptState == 0) {
                    // 全部验收、未验收
                    filterItems.returnFlag = false;
                    filterItems.returnState = null;
                } else {
                    filterItems.returnFlag = null;
                }
            }
            //
            let transFlag = filterItems.transFlag;
            if(!Utils.isNoB(transFlag)) {
                filterItems.invalid = false;
                if(transFlag == 4) {
                    filterItems.applyState = 0;
                } else if(transFlag == 0) {
                    filterItems.applyState = 1;
                    filterItems.auditState = 0;
                } else if(transFlag == 2) {
                    filterItems.confirmState = getEnumInfoWith('confirmState', 'name', 'Confirmed').value;
                } else if(transFlag == 3) {
                    filterItems.auditState = 1;
                    filterItems.confirmState = getEnumInfoWith('confirmState', 'name', 'None').value;
                } else if(transFlag == -2) {
                    filterItems.invalid = true;
                } else {
                    filterItems.auditState = transFlag;
                }
            }
            if(!Utils.isNoB(this.selectComId)) {
                filterItems.reailerShopId = self.selectComId;
            }
            if(!Utils.isNoB(this.bizUnitId)) {
                filterItems.bizUnitId = self.bizUnitId;
            }
            filterItems.includeSubComs = this.includeSubComs;
            filterItems.bizType = 'allot';
            //
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            self.exportFilter = Utils.merge({}, filterItems);
            //
            let theLoad = MsgBox.loading();
            assetVchrApi.getShopDeviceTransVoucherList(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    let shopDeviceTransVoucherList = result.data.rows || [];
                    let pagination = result.data.pagination;
                    self.renderTable(shopDeviceTransVoucherList, pagination);
                    self.totalCount = pagination.totalCount;
                    // self.getApplyStateInitialTodoCount();
                    // self.getAuditStateAuditFailTodoCount();
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getApplyStateInitialTodoCount: function () {
            let self = this;
            assetVchrApi.getShopDeviceTransVoucherAppStateTodoCount({
                tabFlag: 'out',
                tabCheckFlag: 'applyInitial',
            }, function (result) {
                if(result.type == 'info') {
                    self.initialCount = result.data;
                }
            })
        },
        getAuditStateAuditFailTodoCount: function () {
            let self = this;
            assetVchrApi.getShopDeviceTransVoucherAppStateTodoCount({
                tabFlag: 'out',
                tabCheckFlag: 'applyHandled',
            }, function (result) {
                if(result.type == 'info') {
                    self.auditPassCount = result.data;
                }
            })
        },
        // 导出调拨单
        doExport: function () {
            let self = this;
            let pageSize = getDefaultDownloadPageSize();
            let pages = Math.ceil(self.totalCount / pageSize);
            if(pages > 10) {
                showPageRangeSelDlg('选择导出文件序号', pages, 10, this.lastPageNumber, function (ok, range) {
                    if(ok) {
                        if(range.to == pages) {
                            self.lastPageNumber = 0;
                        } else {
                            self.lastPageNumber = range.to;
                        }
                        //
                        self.exportPrintData(pageSize, range.from, range.to);
                    }
                }, {pageSize: pageSize})
            } else {
                self.exportPrintData(pageSize);
            }
        },
        exportPrintData(pageSize, fromPages, toPages) {
            let totalCount = this.totalCount;
            let pages = Math.ceil(totalCount / pageSize);
            //
            fromPages = fromPages == null ? 1 : fromPages;
            toPages = toPages == null ? pages : toPages;
            let tableData = this.getTableData(pages, pageSize);
            //
            let url = getAppUrl('/file/export/as/excel');
            let downloadUrls = [];
            for(let i = fromPages; i <= toPages; i++) {
                let tmpFile = {};
                tmpFile.url = url;
                tmpFile.post = true;
                tmpFile.fileName = '调拨单' + (pages == 1 ? '' : ('_' + (i)));
                tmpFile.seqNo = i;
                //
                let data = Utils.merge({}, tableData);
                data.pageNumber = i;
                data.fileName = tmpFile.fileName;
                tmpFile.data = data;
                downloadUrls.push(tmpFile);
            }
            let title = '调拨单-下载| 每个文件' + pageSize + '条数据';
            showGrpDownloadDlg(title, downloadUrls);
        },
        getTableData(pages, pageSize) {
            let resultTable = this.$refs.result_table;
            let tableData = resultTable.getTableData(true);
            delete tableData.rows;//减少数据传输量
            //
            let rowsSrc = {};
            rowsSrc.data = this.getPostData();
            rowsSrc.url = '/asset/vchr/trans/voucher/list/get';
            tableData.rowsSrc = rowsSrc;
            //
            tableData.pageSize = pageSize;
            tableData.pageCount = this.totalCount;
            tableData.pages = pages;
            return tableData;
        },
        getPostData() {
            let queryModel = this.queryModel;
            let filterItems = Utils.merge({}, this.exportFilter);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            filterItems.exportFlag = true;
            //
            let postData = {};
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            //
            return postData;
        },
        createTransVoucher: function (autoApplyAndAudit, offline) {
            if(!Utils.repeatChecker.isValidFor('createTransVoucher', 1000)) {
                return;
            }
            offline = offline || false;
            let self = this;
            this.$router.push({
                path: SwbShopDeviceTransVoucherSaveStockFifo.path,
                query: {
                    bizUnitId: self.bizUnitId,
                    bizUnitName: self.bizUnitName,
                    isAuditBpConfAvailable: self.isAuditBpConfAvailable,
                    autoApplyAndAudit: autoApplyAndAudit,
                    offline: offline,
                    parentPath: '/shop/device/trans/voucher/apply/list'
                }
            });
        },
        viewTransVoucher: function (row) {
            let self = this;
            let title = '资产调拨-详情';
            if(row.reserveFlag) {
                title = '预定调拨-详情';
            }
            Vue.$showDialog({
                title: title,
                width: -200,
                height: -100,
                okVisible: false,
                showCloseBtn: true,
                cancelText: '关闭',
                template: '<swb-trans-voucher-view :parentSelf="parentSelf" :id="id" :reserveFlag="reserveFlag"></swb-trans-voucher-view>',
                data: {
                    parentSelf: self,
                    id: row.id,
                    reserveFlag: row.reserveFlag
                }
            });
        },
        editorTransVoucher: function (row) {
            let self = this;
            let path = SwbShopDeviceTransVoucherSaveStockFifo.path;
            this.$router.push({
                path: path,
                query: {
                    id: row.id,
                    isAuditBpConfAvailable: self.isAuditBpConfAvailable,
                    parentPath: '/shop/device/trans/voucher/apply/list'
                }
            });
        },
        // 调拨单申请操作
        applyTransVoucher: function (row) {
            let self = this;
            if(self.dingDingAuditFlag) {
                openAuditTypeDlg(null, function (auditType, theDlg) {
                    theDlg.close();
                    let dingDingFlag = Utils.isTrue(auditType);
                    if(dingDingFlag) {
                        let params = {
                            bizVoucherId: row.id,
                            bizVoucherNo: row.innerNo,
                            bizTypeCode: 'retailer.assets.allot',
                        };
                        openDingdingAuditViewDlg(params, function (resultData) {
                            let departId = resultData.departId;
                            // 返回值：departId（部门ID）
                            row.dingDingFlag = dingDingFlag;
                            self.toAuditBpConf(row, [], null, departId, null);
                        });
                    } else {
                        // 申请内部审批
                        self.toInnerApplyTransVoucher(row);
                    }
                });
            } else if(self.feiShuAuditFlag) {
                // 飞书审批
                // openAuditTypeDlg('feishu', function (auditType, theDlg) {
                //     theDlg.close();
                //     let feiShuFlag = Utils.isTrue(auditType);
                //     if(feiShuFlag) {
                //         let params = {
                //             bizVoucherId: row.id,
                //             bizVoucherNo: row.innerNo,
                //             bizTypeCode: 'retailer.assets.allot'
                //         };
                //         openFeiShuAuditViewDlg(params, function (resultData) {
                //             let departId = resultData.departId;
                //             //
                //             row.feiShuFlag = feiShuFlag;
                //             self.toAuditBpConf(row, [], null, departId);
                //         });
                //     } else {
                //         // 申请内部审批
                //         self.toInnerApplyTransVoucher(row);
                //     }
                // });

                let params = {
                    bizVoucherId: row.id,
                    bizVoucherNo: row.innerNo,
                    bizTypeCode: 'retailer.assets.allot'
                };
                openFeiShuAuditViewDlg(params, function (resultData) {
                    let departId = resultData.departId;
                    let decisionBasisVal = resultData.decisionBasisVal;
                    row.bizScenario = resultData.bizScenario || null;
                    //
                    row.feiShuFlag = true;
                    self.toAuditBpConf(row, [], null, departId, decisionBasisVal);
                });
            } else {
                if(Utils.isTrue(self.isAuditBpConfAvailable)) {
                    if(self.needAssignAuditors) {
                        let params = {
                            bizTypeCode: 'retailer.assets.allot',
                            bizVoucherNo: row.innerNo || row.no,
                            auditSeqNo: row.auditSeqNo
                        };
                        openOaAuditBpNodeDlg(params, function (auditorList, theDlg) {
                            auditorList = auditorList || [];
                            if(auditorList.length <= 0) {
                                MsgBox.warning('无审批人员信息');
                                return;
                            }
                            //
                            self.toAuditBpConf(row, auditorList, theDlg);
                        });
                    } else {
                        self.toAuditBpConf(row, [], null);
                    }
                } else {
                    // 内部申请审批
                    self.toInnerApplyTransVoucher(row);
                }
            }
        },
        // 内部申请
        toInnerApplyTransVoucher: function (row) {
            let self = this;
            // 获取最近一次审核人信息
            let params = {
                bizUnitId: row.srcBizUnitId,
                voucherType: getEnumInfoWith('devcVoucherType', 'name', 'Allocation').value
            };
            let theLoad = MsgBox.loading();
            shopDevcApi.getLastAuditInfo(params, function (resultX) {
                theLoad.hide();
                if(resultX.type == 'info') {
                    let auditInfo = resultX.data;
                    let initPostId = row.auditorPostId;
                    let auditorStaffId = row.auditorStaffId;
                    let auditorName = row.auditorName;
                    if(!Utils.isNoB(auditInfo) && auditInfo.postId > 0) {
                        initPostId = auditInfo.postId;
                        auditorStaffId = auditInfo.staffId;
                        auditorName = auditInfo.staffName;
                    }
                    // 走内部审批
                    showComActionPostSelectDlg({
                        title: '调拨申请 - 指定审核岗',
                        rescUrl: SwbShopDeviceTransVoucherAuditList.path,
                        action: 'audit',
                        initPostId: initPostId,
                        useParents: true,
                        expandedParents: true,
                        showAuditor: !Utils.isNoB(auditorStaffId),
                        showAuditStaff: true,
                        auditorStaffId: auditorStaffId,
                        auditorName: auditorName,
                        useDesc: false
                    }, function (resultData) {
                        resultData = resultData || {};
                        if(resultData.postId == null) {
                            Toast.show('请选择审核岗位', 3000, 'warning');
                            return false;
                        }
                        //
                        let postData = {
                            id: row.id,
                            auditorPostId: resultData.postId,
                            auditorPostName: resultData.postName,
                            auditComId: resultData.comId,
                            auditComName: resultData.comName,
                            auditComLevel: resultData.comLevel,
                            auditorStaffId: resultData.auditorStaffId,
                            auditorName: resultData.auditorName,
                            applyDesc: resultData.applyDesc
                        };
                        //
                        let theLoad = MsgBox.loading();
                        assetVchrApi.applyShopDeviceTransVoucher(postData, function (result) {
                            theLoad.hide();
                            if(result.type == 'info') {
                                MsgBox.success('申请成功！');
                                self.getShopDeviceTransVoucherList(self.checkStateValue);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }, this);
                } else {
                    MsgBox.warning(resultX.message);
                }
            });
        },
        toAuditBpConf: function (row, auditorList, theDlg, departId, decisionBasisVal) {
            let self = this;
            let postData = {
                id: row.id,
                no: row.no,
                auditorList: Utils.merge([], auditorList),
                //
                dingdingFlag: row.dingDingFlag,
                feiShuFlag: row.feiShuFlag,
                decisionBasisVal: decisionBasisVal,
                bizScenario: row.bizScenario || null
            };
            if(typeof departId === 'string') {
                postData.feiShuDepartId = departId || null
            } else {
                postData.departId = departId || null
            }
            let theLoad = MsgBox.loading();
            assetVchrApi.applyShopDeviceTransVoucher(postData, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    if(!Utils.isNoB(theDlg)) {
                        theDlg.close();
                    }
                    MsgBox.success('申请成功！');
                    self.getShopDeviceTransVoucherList(self.checkStateValue);
                    if(!self.needAssignAuditors) {
                        let auditBpStateInfo = result.data || {};
                        if(Utils.isTrue(auditBpStateInfo.outerAuditFlag) && !Utils.isTrue(auditBpStateInfo.bpStarted) && auditBpStateInfo.auditState == 0) {
                            let params = {
                                no: auditBpStateInfo.voucherNo
                            };
                            self.openOuterBpStartWin(params);
                        }
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 删除调拨单
        doDeleteTransVoucher: function (id) {
            let self = this;
            self.$confirm('确定要删除该信息吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let postData = {};
                postData.id = id;
                let theLoad = MsgBox.loading();
                assetVchrApi.deleteShopDeviceTransVoucher(postData, function (result) {
                    theLoad.hide();
                    if(result.type === 'info') {
                        self.getShopDeviceTransVoucherList(self.checkStateValue);
                        MsgBox.success('删除成功!');
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            });
        },
        // 作废调拨单
        doInvalidTransVoucher: function (id) {
            let self = this;
            self.$confirm('确定要作废该信息吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let postData = {};
                postData.id = id;
                let theLoad = MsgBox.loading();
                assetVchrApi.doInvalidTransVoucher(postData, function (result) {
                    theLoad.hide();
                    if(result.type === 'info') {
                        self.getShopDeviceTransVoucherList(self.checkStateValue);
                        MsgBox.success('作废成功!');
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }).catch(function () {
            });
        },
        toViewAuditRec: function (id) {

            Vue.$showDialog({
                title: '资产调拨审核--详情',
                width: 1000,
                height: 600,
                okVisible: false,
                showCloseBtn: true,
                cancelText: '关闭',
                template: '<div>' +
                    '<swb-shop-device-trans-audit-rec-list :voucherId="voucherId"></swb-shop-device-trans-audit-rec-list>' +
                    '</div>',
                data: {
                    voucherId: id,
                }
            });
        },
        // @date 2019-02-24 13:20 @auther libin @desc 增加操作记录
        showActRec(no) {
            Vue.$showDialog({
                title: '调拨单操作记录 - 查看',
                width: 1200,
                height: 750,
                okVisible: false,
                showCloseBtn: true,
                okClicked: false,
                cancelText: '关闭',
                template: '<div>' +
                    '<swb-shop-device-act-rec-list :showComFlag="true" :srcVoucherNo="srcVoucherNo" :srcVoucherType="srcVoucherType" ref="swb_shop_device_act_rec_list"></swb-shop-device-act-rec-list>' +
                    '</div>',
                data: {
                    srcVoucherNo: no,
                    srcVoucherType: getEnumInfoWith('devcVoucherType', 'name', 'Allocation').value
                }
            });
        },
        pdfExport: function (id) {
            openTrandVouhcerPdfDlg(id);
        },
        returnTransVoucher: function (id) {
            let self = this;
            openShopDeviceTransVoucherReturnSaveDlg(id, function (postData, theDlg) {
                self.$confirm('确定要退还该信息吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    assetVchrApi.saveShopDeviceTransVoucherForDirectFlag(postData, function (result) {
                        theLoad.hide();
                        if(result.type == 'info') {
                            theDlg.close();
                            MsgBox.success('操作成功');
                            //
                            self.getShopDeviceTransVoucherList(self.checkStateValue);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherApplyList.vue